import React from 'react';
import { Card } from './ui/card';

const FloatingCard = ({ 
  children, 
  className = '', 
  delay = 0,
  duration = 3,
  ...props 
}) => {
  return (
    <Card
      className={`
        ${className}
        animate-float
        hover:shadow-2xl 
        transition-all 
        duration-300 
        transform 
        hover:scale-105
        border-0 
        shadow-lg
      `}
      style={{
        animationDelay: `${delay}s`,
        animationDuration: `${duration}s`
      }}
      {...props}
    >
      {children}
    </Card>
  );
};

export default FloatingCard;